import { ElectricityAgreement } from 'models/electricity/agreement';
import { ISortedPageRequest } from "../common/interfaces/IPageRequest";
import { ChargingAgreement } from './charging/agreement';


export interface IAgreement {
    id: number;
    customerId: number;
    customerName: number;
    remoteCustomerId: number;
    remoteAgreementId: number;
    fileName: string;
    contractNumber: string;
    type: IAgreementType;
    dateModified: string;
    isSignedByCustomer: boolean;
    isSignedByVendor: boolean;
    signers?: IAgreementSigner[];
}

export interface IAgreementSigner {
    name: string;
    idCode: string;
    dateSigned: string | null;
    isSigned: boolean;
}

export enum IAgreementsSortFields {
    ID = "ID",
    CONTRACT_NUMBER = "CONTRACT_NUMBER",
    TYPE = "TYPE",
    DATE_MODIFIED = "DATE_MODIFIED"
}

export interface IAgreementRequest extends ISortedPageRequest<IAgreementsSortFields> {
  statuses?: string | string[];
}

export enum IAgreementType {
    PURCHASE_AND_SALE = "PURCHASE_AND_SALE",
    ADDITIONAL_ADDENDUM = "ADDITIONAL_ADDENDUM",
    SURETY = "SURETY",
    CREDIT_CARD = "CREDIT_CARD",
    PRIVATE_CLIENT_CREDIT = "PRIVATE_CLIENT_CREDIT",
    CREDIT_CARD_ADDENDUM = "CREDIT_CARD_ADDENDUM",
    ELECTRICITY = 'ELECTRICITY',
    CHARGING = 'CHARGING'
}

export const AGREEMENT_TYPE_MAP: {[key in IAgreementType]: string} = {
    PURCHASE_AND_SALE: 'Ostu-müügileping',
    ADDITIONAL_ADDENDUM: 'Müügilepingu lisa',
    SURETY: 'Käendusleping',
    CREDIT_CARD: 'Krediitkaardi leping',
    CREDIT_CARD_ADDENDUM: 'Krediitkaardi lepingu lisa',
    PRIVATE_CLIENT_CREDIT: 'Krediidileping',
    ELECTRICITY: 'Elektrileping',
    CHARGING: 'Laadimisleping'
};

export enum AgreementSigningStatus {
    PREPARED = 'PREPARED',
    PENDING_CUSTOMER = 'PENDING_CUSTOMER',
    PENDING_VENDOR = 'PENDING_VENDOR',
    COMPLETED = 'COMPLETED'
}

export const AGREEMENT_SIGNING_STATUS_MAP: {[key in AgreementSigningStatus]: string} = {
    PREPARED: 'Allkirjastamiseks',
    PENDING_CUSTOMER: 'Terminali poolt allkirjastatud',
    COMPLETED: 'Allkirjastatud',
    PENDING_VENDOR: 'Allkirjastamisel'
};

export type AgreementListItem = IAgreement | { type: IAgreementType } & ElectricityAgreement | {type: IAgreementType } & ChargingAgreement; 